module.exports = __webpack_public_path__ + "img/towCode.fbfc27c5.jpg";